import { render, staticRenderFns } from "./404.vue?vue&type=template&id=5ff19612&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=5ff19612&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff19612",
  null
  
)

export default component.exports